import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MembershipCodeService } from '../services/membership-code.service';
import { SortableComponent } from '../../core/sortable/sortable.component';
import { RouteHelperService } from '../../core/services/route-helper.service';
import { PageParamStorageService } from '../../core/services/page-param-storage.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'ch-membership-code-listing',
  templateUrl: './membership-code-listing.component.html',
  styleUrls: ['./membership-code-listing.component.css'],
})
export class MembershipCodeListingComponent implements OnInit, OnDestroy {
  public items = [];
  public totalItems;
  public pageParams: any = {};
  public types: any[] = [
    {
      name: 'All Types',
      value: '',
    },
    {
      name: 'Discount - Employment Proof Required',
      value: 'DISCOUNT',
    },
    {
      name: 'Staff Incentive - Employment Stage Skipped',
      value: 'STAFF_INCENTIVE',
    },
  ];
  public activeTypes: any[] = [
    {
      name: 'All Statuses',
      value: '',
    },
    {
      name: 'Active',
      value: 'ACTIVE',
    },
    {
      name: 'Expired',
      value: 'EXPIRED',
    },
  ];
  private filterFields: string[] = ['status', 'type', 'search', 'pageSize'];

  public loading: boolean;

  constructor(
    private membershipCodeService: MembershipCodeService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private routeHelperService: RouteHelperService,
    private pageParamStorageService: PageParamStorageService,
    private titleService: Title,
  ) {}

  ngOnInit() {
    this.titleService.setTitle(`Membership Codes | CODE Hospitality CMS`);
    this.activatedRoute.queryParamMap
      .map((params: Params) => params.params)
      .subscribe(params => {
        if (Object.keys(params).length === 0 && this.pageParamStorageService.pageParams) {
          params = this.pageParamStorageService.pageParams;
          this.queryParams(params);
        }
        this.pageParams = this.routeHelperService.getValidatedParams(params);
        this.loadItems(this.pageParams);
        this.pageParamStorageService.pageParams = this.pageParams;
      });
  }

  ngOnDestroy(): void {
    this.titleService.setTitle(`CODE Hospitality CMS`);
  }

  public statusChanged(event) {
    this.filterSearch({
      status: event.target.value,
    });
  }

  public typeChanged(event) {
    const value = event.target.value;
    this.filterSearch({
      type: value,
    });
  }

  public search(event) {
    this.filterSearch({
      search: event,
    });
  }

  private filterSearch(data) {
    const result = {};
    for (const field of this.filterFields) {
      result[field] = null != data[field] ? data[field] : this.pageParams[field];
    }

    this.router.navigate([], { queryParams: result });
  }

  public onSort(data) {
    this.queryParams({
      sortBy: data.column,
      sortOrder: data.order,
    });
  }

  public onPageChanged(page) {
    this.queryParams({
      pageNumber: page.pageNumber,
      pageSize: page.pageSize,
    });
  }

  private queryParams(params) {
    const result = this.routeHelperService.queryParams(params, this.pageParams);
    this.router.navigate([], { queryParams: result });
  }

  private loadItems(data) {
    this.loading = true;
    this.membershipCodeService.getMembershipCodes(data).subscribe(result => {
      const jsonData = result.json();
      this.items = jsonData.items;
      this.totalItems = jsonData.totalItems;
      this.loading = false;
    });
  }

  public getTypeReadable(type) {
    return this.membershipCodeService.getTypeReadable(type);
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/membership-code/membership-code-listing/membership-code-listing.component.ts